import { IconType } from "@/types/utils";
import React from "react";

const BagIcon: IconType = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.666 17.3335C21.666 20.325 19.2409 22.7501 16.2493 22.7501L12.4577 22.7501L9.74935 22.7501C6.75781 22.7501 4.33268 20.325 4.33268 17.3335L4.33268 11.9168L4.37127 11.3765C4.65473 7.40811 7.95683 4.33346 11.9353 4.33346L12.4577 4.33346L14.0634 4.33346C18.0419 4.33346 21.344 7.40811 21.6274 11.3765L21.666 11.9168L21.666 17.3335Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M16.6104 10.8334C16.6104 10.8334 16.6103 14.3979 12.9992 14.3979C9.38813 14.3979 9.38811 10.8334 9.38811 10.8334"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BagIcon;
